export default function IconHeadingBig({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 29.8849 23.7704"
      fill="none"
      className={className}
    >
      <path
        d="M1.69 1.69V11.8848M1.69 11.8848V22.0795M1.69 11.8848L15.9616 11.8857M15.9616 11.8857V1.69099M15.9616 11.8857V22.0804M22.0786 10.3547L25.1368 8.31586V22.0788M25.1368 22.0788H22.0786M25.1368 22.0788H28.1949"
        stroke="currentColor"
        vectorEffect="non-scaling-stroke"
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
